import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IndividualConsumptionsResponse } from './individual-consumption-table.types';
import { IndividualConsumptionsPayload } from './store/individual-consumption-table.state';

@Injectable({ providedIn: 'root' })
export class IndividualConsumptionTableAPIService {
  private readonly httpClient = inject(HttpClient);

  getListingData(payload: IndividualConsumptionsPayload): Observable<IndividualConsumptionsResponse> {
    return this.httpClient.post<IndividualConsumptionsResponse>(`/api/individual-consumptions`, payload);
  }
}
